module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "copyright-page",
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "_cip",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Copyright Information")]), _vm._v(" "), _c('p', {
    staticClass: "CIP-page"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("The Hearth Witch’s Kitchen Herbal: Culinary Herbs for Magic, Beauty, and Health")]), _vm._v(" © 2019 by Anna Franklin. ")])]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any matter whatsoever, including Internet usage, without written permission from Llewellyn Publications, except in the form of brief quotations embodied in critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("As the purchaser of this e-book, you are granted the non-exclusive, non-transferable right to access and read the text of this e-book on screen. The text may not be otherwise reproduced, transmitted, downloaded, or recorded on any other storage device in any form or by any means. ")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Any unauthorized usage of the text without express written permission of the publisher is a violation of the author’s copyright and is illegal and punishable by law.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("First e-book edition © 2019")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("E-book ISBN: 9780738758237")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Book design by Rebecca Zins")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Cover design by Shira Atakpu")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Llewellyn is a registered trademark of Llewellyn Worldwide Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Names: Franklin, Anna author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Title: The hearth witch’s kitchen herbal : culinary herbs for magic, beauty,")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   and health / Anna Franklin.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Description: Woodbury, Minnesota : Llewellyn Publications, [2019] | Includes")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Identifiers: LCCN 2018057738 (print) | LCCN 2019001673 (ebook) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   9780738758237 | ISBN 9780738757896")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Subjects: LCSH: Witchcraft. | Herbs—Miscellanea. | Herbs—Therapeutic use. |")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   Formulas, recipes, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("Classification: LCC BF1566 (ebook) | LCC BF1566 .F695 2019 (print) | DDC")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("   133.4/3—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip1-nosp"
  }, [_vm._v("LC record available at "), _c('span', {
    staticClass: "link"
  }, [_vm._v("https://lccn.loc.gov/2018057738")])]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("note")]), _vm._v(": The information in this book is provided for educational and entertainment purposes only. It does not constitute a recommendation for use.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Llewellyn Publications does not participate in, endorse, or have any authority or responsibility concerning private business arrangements between our authors and the public.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2-spab"
  }, [_vm._v("Any Internet references contained in this work are current at publication time, but the publisher cannot guarantee that a specific reference will continue or be maintained. Please refer to the publisher’s website for links to current author websites.")]), _vm._v(" "), _c('p', {
    staticClass: "cip3-spab-cntr"
  }, [_vm._v("Llewellyn Publications ")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("Llewellyn Worldwide Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("2143 Wooddale Drive")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_vm._v("Woodbury, MN 55125")]), _vm._v(" "), _c('p', {
    staticClass: "cip34-nosp-cntr"
  }, [_c('a', {
    attrs: {
      "href": "http://www.llewellyn.com",
      "target": "_blank"
    }
  }, [_vm._v("www.llewellyn.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cip3-spab-cntr"
  }, [_vm._v("Manufactured in the United States of America")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25dbd17e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 63
// module chunks = 0